import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ left: 0, top: 0 });
  }, [pathname]);
};

export default useScrollToTop;
